/* TODO: Check if the context types from context service can be used here */
export class ActionMenuContext {
    type: string;
    value: any;
    subtype: string; /* to indicate whether an account is a managed account, BC account, etc */
    status: string; /* Open / Close / Pending */
    key: string; /* Unique key to identify the menus. When we need more than context type/subtype to determine the menus */
    actionMenuFlags: string[]; /* Flags that control menu display/behavior */
    attributes: Map<string, string>; /* Dummy */
}
